module.exports = __webpack_public_path__ + "greece.svg?90595896067c8dca8953210ba731be3e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/greece.svg
// module id = 176
// module chunks = 10